module.exports = __webpack_public_path__ + "media/images/lb/584-d72491b646745f111e960665dfd68917.svg";